import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { AddressPickerComponent } from '../components/address-picker/address-picker.component';
import { AutoCompleteInputComponent } from '../components/autocomplete-input/autocomplete-input.component';
import { ButtonPickerComponent } from '../components/button-picker/button-picker.component';
import { ButtonToggleComponent } from '../components/button-toggle/button-toggle.component';
import { CarPickerComponent } from '../components/car-picker/car-picker.component';
import { CheckboxComponent } from '../components/checkbox/checkbox.component';
import { ControlErrorComponent } from '../components/control-error/control-error.component';
import { FormFieldComponent } from '../components/form-group/form-field/form-field.component';
import { FormGroupHeaderComponent } from '../components/form-group/form-group-header/form-group-header.component';
import { FormGroupPartHeaderComponent } from '../components/form-group/form-group-part-header/form-group-part-header.component';
import { FormGroupPartItemTitleComponent } from '../components/form-group/form-group-part-item-title/form-group-part-item-title.component';
import { FormGroupPartItemComponent } from '../components/form-group/form-group-part-item/form-group-part-item.component';
import { FormGroupPartComponent } from '../components/form-group/form-group-part/form-group-part.component';
import { FormGroupComponent } from '../components/form-group/form-group.component';
import { GeoAutoCompleteComponent } from '../components/geo-autocomplete/geo-autocomplete.component';
import { HighlightComponent } from '../components/highlight.component';
import { ChequeNumberInputComponent } from '../components/inputs/cheque-number-input.component';
import { DateInputComponent } from '../components/inputs/date-input.component';
import { IbanInputComponent } from '../components/inputs/iban-input.component';
import { MailInputComponent } from '../components/inputs/mail-input.component';
import { NumeroOrgaAffiliationInputComponent } from '../components/inputs/num-orga-affiliation';
import { PasswordInputComponent } from '../components/inputs/password-input.component';
import { PhoneInputComponent } from '../components/inputs/phone-input.component';
import { PolicyRefInputComponent } from '../components/inputs/policy-ref-input.component';
import { SirenInputComponent } from '../components/inputs/siren-input.component';
import { SiretInputComponent } from '../components/inputs/siret-input.component';
import { TextInputComponent } from '../components/inputs/text-input.component';
import { RadioComponent } from '../components/radio/radio.component';
import { ReadonlyFieldComponent } from '../components/readonly-field/readonly-field.component';
import { Select2Component } from '../components/select2/select2.component';
import { AtLeastOneLetterRequiredDirective } from '../directives/at-least-one-letter-required.directive';
import { AtLeastOneRequiredDirective } from '../directives/at-least-one-required.directive';
import { IsValidDirective } from '../directives/is-valid.directive';
import { PasswordEqualValidatorDirective } from '../directives/password-equal-validator.directive';
import { RangeValidatorDirective } from '../directives/range.directive';
import { RequiredTrueDirective } from '../directives/required-true.directive';
import { StringNotEmptyAndTrimmedDirective } from '../directives/string-not-empty-and-trimmed';
import { SAFE_PIPES } from '../pipes/safe-html.pipe';

export const wzFormsExportedComponents = [
  AddressPickerComponent,
  TextInputComponent,
  PhoneInputComponent,
  Select2Component,
  RadioComponent,
  ButtonToggleComponent,
  CheckboxComponent,
  MailInputComponent,
  IbanInputComponent,
  ControlErrorComponent,
  AutoCompleteInputComponent,
  HighlightComponent,
  GeoAutoCompleteComponent,
  DateInputComponent,
  SiretInputComponent,
  PolicyRefInputComponent,
  SirenInputComponent,
  PasswordInputComponent,
  FormGroupComponent,
  FormGroupHeaderComponent,
  FormGroupPartComponent,
  FormGroupPartHeaderComponent,
  FormGroupPartItemComponent,
  FormGroupPartItemTitleComponent,
  CarPickerComponent,
  ButtonPickerComponent,
  ReadonlyFieldComponent,
  ChequeNumberInputComponent,
  FormFieldComponent,
  NumeroOrgaAffiliationInputComponent,
];

export const wzFormsExportedPipes = [SAFE_PIPES];
export const wzFormsExportedDirectives = [
  AtLeastOneRequiredDirective,
  IsValidDirective,
  StringNotEmptyAndTrimmedDirective,
  AtLeastOneLetterRequiredDirective,
  PasswordEqualValidatorDirective,
  RequiredTrueDirective,
  RangeValidatorDirective,
];

export const wzFormsMaterialExports = [
  MatFormFieldModule,
  MatInputModule,
  MatSelectModule,
  MatCheckboxModule,
  MatRadioModule,
  MatExpansionModule,
  MatProgressBarModule,
  MatButtonToggleModule,
];
